/**
 * billingApi — web wrapper. Mirrors the RN surface so callers (Entitlements,
 * useAccount, LowBalanceMonitor) work unchanged.
 */
import {
  createBillingApi,
  formatVoiceTime,
  isBalanceDepleted,
  isCriticalBalance,
  isLowBalance,
} from '@wg/api/billing';
import type { BillingApi } from '@wg/api/billing';
import { httpClient } from '../http';
import logger from '../utils/logger';

const api: BillingApi = createBillingApi(httpClient, logger);

export const getUserBalance = api.getUserBalance;
export const checkEntitlement = api.checkEntitlement;
export const getUserEntitlements = api.getUserEntitlements;
export const getUserTransactions = api.getUserTransactions;
export const getUserSessions = api.getUserSessions;
export const getSessionUsage = api.getSessionUsage;
export const redeemCode = api.redeemCode;
export const syncRevenueCatSubscriptions = api.syncRevenueCatSubscriptions;
export const getGrantTypeConfigs = api.getGrantTypeConfigs;
export const registerDevice = api.registerDevice;
export const getUserDevices = api.getUserDevices;
export const updateDevice = api.updateDevice;
export const unregisterDevice = api.unregisterDevice;
export const sendTestNotification = api.sendTestNotification;
export const getNotificationHistory = api.getNotificationHistory;
export const markNotificationClicked = api.markNotificationClicked;

export { formatVoiceTime, isLowBalance, isCriticalBalance, isBalanceDepleted };

export const billingApi = api;
export default api;
export type { BillingApi };
export type {
  BalanceResponse,
  EntitlementStatus,
  Entitlement,
  TransactionsResponse,
  UsageEvent,
  SessionDetails,
  GrantTypeConfig,
  RegisterDeviceRequest,
  UserDevice,
} from '@wg/types';
